<template lang="pug">
	.cb(:class="{'checked' : value }")
		label()
			span.checkbox-container
				input(type="checkbox" :true-value="true" :false-value="false" @change="emitChange($event)" :value="value" :checked="value")
				span.checkmark-container
					span.checkmark.white
			span {{cbLabel}}
</template>

<style lang="stylus" scoped>
	@import '~assets/css/variables.styl'
	.cb
		margin: 5px 0
		label
			cursor: pointer
			.checkbox-container
				cursor pointer
				margin 0
				position relative
				display: inline-block
				z-index: 49
				margin-right: 10px
				top: 2px
				transition-all()
				height: 15px
				width: 15px
				border 1px solid sfc-blue-border
				box-shadow-cb()
				input
					position absolute
					z-index: 50
					opacity 0
					width: 100%
					height: 100%
					cursor pointer
					-webkit-user-select none
					-moz-user-select none
					-ms-user-select none
					user-select none
					& ~ .checkmark-container
						position: absolute
						top: 0
						left: 0
						width: 100%
						height: 100%
						.checkmark
							opacity 0
		.checkmark
			transition-all()
			position relative
			top -8px
			left: 2px
			height: 5px
			width: 8px
			border-left: 2px solid #fff
			border-bottom: 2px solid #fff
		&.checked
			.checkbox-container
				border: 1px solid sfc-blue-border
				input
					&:checked
						& ~ .checkmark-container
								border-color sfc-blue-border
								background: sfc-blue
								.checkmark
									opacity 1
</style>
<script>
export default {
	props: {
		cbLabel:{
			default: false
		},
		value:{
			default: false
		}
	},
	methods: {
		emitChange(event) {
			this.$emit('input', event.target.checked)
			this.$emit('change', event)
		}
	}
}
</script>
